
import { useI18n } from "vue-i18n";
import { defineComponent, ref, computed, onMounted, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import * as Paylink from "@/api/paylink";
import { Field, Cell, Toast, Button, Popover } from "vant";
export default defineComponent({
  name: "paylink",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Popover.name]: Popover
  },
  setup() {
    const route = useRoute();
    const { t, locale } = useI18n();
    const showPopover = ref(false);
    const { id, lang } = route.query;
    const currentLang = ref();
    const dev = process.env.VUE_APP_BUILD_ENV;
    let data = reactive({
      langs: [
        { text: "简体中文", value: "cn" },
        { text: "English", value: "en" }
      ]
    });

    currentLang.value = lang ?? "en";
    watch(
      currentLang,
      newLang => {
        locale.value = newLang;
      },
      {
        immediate: true
      }
    );
    const changeLang = item => {
      locale.value = item.value;
    };
    const convertLangName = computed(() => {
      return (
        data.langs.find(x => {
          return x.value === locale.value;
        })?.text || ""
      );
    });

    interface InfoObject {
      amount: number;
      status: string;
      business_identifier: string;
      business_name: string;
      currency: string;
      expandable: boolean;
      logo_url: string;
      product_name: string;
      remark: string;
    }
    const info = ref<InfoObject>({
      amount: 0,
      status: "",
      business_identifier: "",
      business_name: "",
      currency: "",
      expandable: false,
      logo_url: "",
      product_name: "",
      remark: ""
    });
    const getPayOrderInfo = async () => {
      const loadingToast = Toast({
        message: "",
        type: "loading"
      });
      const res = await Paylink.GetPayOrderInfo();
      loadingToast.close();
      if (res?.code == 200) {
        info.value = res?.data;
      } else if (res?.code == 40050) {
        info.value.status = "EXPIRED";
      } else {
        res?.message &&
          Toast({
            message: res?.message,
            overlay: false,
            duration: 3000
          });
      }
    };

    const forms = ref({
      pay_link_no: id,
      out_user_name: "",
      phone_number: "",
      email: "",
      remark: ""
    });

    const emailError = ref(false);
    const validatorEmail = () => {
      if (
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(forms.value.email) &&
        forms.value.email.length <= 50
      ) {
        emailError.value = false;
        return true;
      } else {
        emailError.value = true;
        return false;
      }
    };

    const isDisableConfirm = computed(() => {
      if (!forms.value.out_user_name || !forms.value.phone_number || !forms.value.email) {
        return true;
      }
      if (!validatorEmail()) {
        return true;
      }
      return false;
    });

    const confirm = async () => {
      if (isDisableConfirm.value) {
        return;
      }
      const res = await Paylink.CreatePayOrder({
        pay_link_no: forms.value.pay_link_no as string,
        email: forms.value.email,
        out_user_name: forms.value.out_user_name,
        phone_number: forms.value.phone_number,
        remark: forms.value.remark
      });
      if (res?.code == 200) {
        // window.location.href = res?.data?.payment_url;
        const win = window.open(res?.data?.payment_url, "_self");
        window["win"] = win;
      } else {
        res?.message &&
          Toast({
            message: res?.message,
            overlay: false,
            duration: 3000
          });
      }
    };

    onMounted(() => {
      getPayOrderInfo();
    });

    return {
      dev,
      data,
      convertLangName,
      currentLang,
      showPopover,
      changeLang,

      info,
      forms,
      isDisableConfirm,
      confirm,
      emailError,
      validatorEmail
    };
  }
});
